'use client';

import { c as _c } from "react/compiler-runtime";
import { Toaster as ChakraToaster, Portal, Spinner, Stack, Toast, createToaster } from '@chakra-ui/react';
export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true
});
export const Toaster = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Portal><ChakraToaster insetInline={{
        mdDown: "4"
      }} toaster={toaster}>{_temp}</ChakraToaster></Portal>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(toast) {
  return <Toast.Root width={{
    md: "sm"
  }}>{toast.type === "loading" ? <Spinner color="blue.solid" size="sm" /> : <Toast.Indicator />}<Stack flex="1" gap="1" maxWidth="100%">{toast.title && <Toast.Title>{toast.title}</Toast.Title>}{toast.description && <Toast.Description>{toast.description}</Toast.Description>}</Stack>{toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}{toast.closable && <Toast.CloseTrigger />}</Toast.Root>;
}